import React, { useState } from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import { useDocuments } from '../../Data/Documents';
import { PageLoading } from '../../Components/Loading';
import NoItems from '../../Components/EmptyStates/NoItems';
import AddDocument from './AddDocument';
import Dropdown from '../../Components/Dropdown';
import { useDialogues } from '../../Components/Dialogues';
import { getEntityLink, useDownloadDocument, useRedirect } from '../../Services/helpers';
import VisibilityOptions from '../Document/VisibilityOptions';
import Button from '../../Components/Button/Button';
import Links from './Links';
import Icon from '../../Components/Icons/Icon';

const Documents = () => {
    const {documents, addDocument, deleteDocument, refresh} = useDocuments();
    const [addingDocument, setAddingDocument] = useState(false);
    const [editingVisibilityOptions, setEditingVisibilityOptions] = useState(null);
    const [showingLinks, setShowingLinks] = useState(null);
    const {Redirect, go} = useRedirect();

    return <>
        <TopBar left="BackBtn"
            title="Documents"
            right={<Button theme="light" icon="Plus" onClick={() => setAddingDocument(true)} zeroMargin />}
        />
        <Page>
            {documents ?
                <Inner {...{documents, setAddingDocument, deleteDocument, setEditingVisibilityOptions, setShowingLinks}} /> :
                <PageLoading />
            }
        </Page>

        <AddDocument {...{addingDocument, setAddingDocument, addDocument}}
            onDocumentAdded={(document) => {
                refresh();
                if (document.source !== 'Upload') {
                    go(getEntityLink('Documents/Document', document.id))
                }
            }}
        />
        <VisibilityOptions isOpen={!!editingVisibilityOptions}
            setIsOpen={setEditingVisibilityOptions}
            documentId={editingVisibilityOptions}
        />
        <Links document={showingLinks} isOpen={!!showingLinks} setIsOpen={setShowingLinks} />

        <Redirect />
    </>
}

const Inner = ({documents, setAddingDocument, deleteDocument, setEditingVisibilityOptions, setShowingLinks}) => {
    const {confirm} = useDialogues();
    const downloadDocument = useDownloadDocument();

    return <ul className="divide-y divide-gray-200">
        {documents.map((document, i) => {
            return <li key={document.id} className="flex items-top gap-x-6 py-5">
                <div className="w-[120px]">
                    <div className="p-2 border rounded-lg">
                        {document.thumbnail && <img src={document.thumbnail} alt={document.title} className="w-[100px] h-auto" />}
                        {!document.thumbnail && <div className="text-center bg-slate-100 fill-muted py-12 rounded-lg">
                            <Icon icon="FileLines" size="3x" />
                        </div>}
                    </div>
                </div>
                <div className="grow">
                    <strong>{document.title}</strong><br />
                    <span className="text-muted">{document.category}</span><br />
                    <span className="text-muted">{document.source}</span>
                </div>
                <div>
                    <Dropdown options={[
                        {
                            icon: 'CloudArrowDown',
                            title: 'Download',
                            onClick: () => downloadDocument(document.id, document.key)
                        },
                        {
                            icon: 'Link',
                            title: 'Links',
                            onClick: () => setShowingLinks(document)
                        },
                        {
                            div: true,
                        },
                        {
                            icon: 'Pencil',
                            title: 'Edit',
                            to: `/business/documents/${document.id}`,
                            disabled: document.source === 'Upload'
                        },
                        {
                            icon: 'Paperclip',
                            title: 'Share settings',
                            onClick: () => setEditingVisibilityOptions(document.id)
                        },
                        {
                            icon: 'Trash',
                            title: 'Delete',
                            onClick: () => confirm(
                                {
                                    theme: 'danger',
                                    title: 'Delete Document',
                                    message: `Are you sure you want to delete this document '${document.title}'?`
                                },
                                () => deleteDocument(document.id),
                            )
                        }
                    ]} />
                </div>
            </li>
        })}
        <NoItems icon="FileCertificate"
            title="Add Document"
            message={`
                Add documents that your customers can access.

                For example, use the Terms of Service template to easily create a professional document.

                Or, upload a PDF of your public liability insurance.
            `}
            onClick={() => setAddingDocument(true)}
        />
    </ul>
}

export default Documents;
